var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pc-and-smartphone-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9962 72.5542H17.27C16.2746 72.5542 15.4674 73.361 15.4674 74.3568C15.4674 75.3525 16.2746 76.1593 17.27 76.1593H20.9962C21.9916 76.1593 22.7987 75.3525 22.7987 74.3568C22.7987 73.361 21.9916 72.5542 20.9962 72.5542Z",
    fill: "#FF96F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M75.8885 1.35352H15.3264C10.8535 1.35352 7.21489 4.99251 7.21489 9.465V25.6905H5.58791C2.50663 25.6905 0 28.1971 0 31.2784V77.0582C0 80.1395 2.50663 82.6461 5.58791 82.6461H32.6785C35.7597 82.6461 38.2664 80.1395 38.2664 77.0582V73.0323H57.9246H65.9161C67.4093 73.0323 68.6199 71.8221 68.6199 70.3285C68.6199 68.8349 67.4093 67.6247 65.9161 67.6247H57.9246V62.4571H75.8885C80.3614 62.4571 84 58.8181 84 54.3457V9.465C84 4.99251 80.3614 1.35352 75.8885 1.35352ZM5.58791 31.0981H32.6785C32.7711 31.0981 32.8587 31.1858 32.8587 31.2784V66.8893H5.40766V31.2784C5.40766 31.1858 5.49526 31.0981 5.58791 31.0981ZM32.6785 77.2384H5.58791C5.49526 77.2384 5.40766 77.1508 5.40766 77.0582V70.4944H32.8587V77.0582C32.8587 77.1508 32.7708 77.2384 32.6785 77.2384ZM52.517 67.6247H38.6975V62.4571H52.517V67.6247ZM78.5923 54.3457C78.5923 55.8367 77.3796 57.0495 75.8885 57.0495H38.2664V31.2784C38.2664 28.1971 35.7597 25.6905 32.6785 25.6905H12.6226V9.465C12.6226 7.97393 13.8353 6.76117 15.3264 6.76117H75.8885C77.3796 6.76117 78.5923 7.97393 78.5923 9.465V54.3457Z",
    fill: "#FF96F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.078d818737d2c98eac03eb4d29817f85.svg";
export { ForwardRef as ReactComponent };